export default __webpack_public_path__ + "static/bundle2-8bff21f7c30486481248f8dec634088a.png";